<template>
  <div>
    <!-- <div class="mb-2 ml-3 text-body-2">
      {{prompt}}
    </div> -->
    <v-card class="rounded-lg mb-sm-10 mb-4 elevation-2">
      <v-card-title class="font-weight-bold pb-0" :class="{'px-5': !icon}">
        <v-icon :color="color" v-if="icon" class="mr-4">{{icon}}</v-icon>
        {{title}}
      </v-card-title>
      <v-card-text :class="{'px-5': !icon, 'pl-14 pr-7': icon}">
        {{subtitle}}
      </v-card-text>
      <v-divider class="mb-0"></v-divider>
      <div class="" v-for="(item, index) in items" :key="index">
        <div class="d-flex" v-if="item.paragraph">
          <div class="">
            <v-icon v-if="item.icon" class="mr-1 mt-5 ml-5">{{item.icon}}</v-icon>
          </div>
          <div class="">
            <v-card-title v-if="item.title" class="pb-1 ml-0 pl-4" :class="{'px-5': !icon}">
              {{item.title}}
            </v-card-title>
            <v-card-text :class="{'font-weight-bold': item.bold}">
              {{item.subtitle}}
            </v-card-text>
          </div>
        </div>
        <v-list-item class="mt-0 pl-2"
          v-if="!item.paragraph && (item.action || item.option || item.href)"
          :two-line="!item.lineCount || item.lineCount === 2"
          :three-line="item.lineCount === 3"
          >
          <v-list-item-avatar class="mr-2" v-if="item.icon">
            <v-icon :color="item.color ? item.color : 'primary'">
              {{item.icon}}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-if="item.title" :class="{'font-weight-bold text-h5': item.highlight}">
              <span v-if="item.display === 'date'">
                {{ moment(item.title).format(item.format) }}
              </span>
              <span v-if="!item.display">
                {{item.title}}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.subtitle">
              {{item.subtitle}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <div v-if="itemClickable(item)" style="display: grid;" class="btn-container">
            <v-btn v-for="(button, idx) in buttons"
            :key="idx"
            @click="handleClick(button,item)"
            :href="getHref(button)">
            {{ button.label }}
          </v-btn>
        </div>
        </v-list-item>
        <v-list-item class="mt-0 pl-2"
          v-if="!item.paragraph && !item.action && !item.option && !item.href"
          :two-line="!item.lineCount || item.lineCount === 2"
          :three-line="item.lineCount === 3">
          <v-list-item-avatar class="mr-2" v-if="item.icon">
            <v-icon :color="item.color ? item.color : 'primary'">
              {{item.icon}}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-if="item.title" :class="{'font-weight-bold text-h5': item.highlight}">
              <span v-if="item.display === 'date'">
                {{ moment(item.title).format(item.format) }}
              </span>
              <span v-if="!item.display">
                {{item.title}}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.subtitle">
              {{item.subtitle}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-avatar v-if="itemClickable(item)">
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';

export default {
  name: 'List',
  props: {
    icon: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    prompt: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    subtitle: {
      type: String,
      default: () => '',
    },
    color: {
      type: String,
      default: () => 'primary',
    },
  },
  methods: {
    moment,
    itemClickable(item) {
      return !!item.action || !!item.option || !!item.href;
    },
    handleClick(button, item) {
      if (button.action === 'trigger-widget-open') {
        window.openYabbrWidget();
        return false;
      }

      if (button.action) {
        this.$emit(
          button.action.type,
          {
            key: button.action.trigger,
            body: item.payload,
          },
        );
        return null;
      }

      if (button.option) {
        const opt = {
          key: button.option,
          body: {},
        };

        if (item.localState) {
          Object.keys(item.localState).forEach((ls) => {
            opt.body[ls] = get(this, item.localState[ls]);
          });
        }
        this.$emit('option', opt);
        return null;
      }

      return null;
    },
    getHref(item) {
      if (!item.href) return false;
      return `${item.href}`;
    },
  },
  data() {
    return {
      ...this.mapState('localContext'),
    };
  },
};
</script>
<style lang="scss" scoped>
.v-list-item__subtitle {
  white-space: pre-wrap;
  line-height: 1.5em;
}
.btn-container {
  display: grid;
  * {
  margin-bottom: 1em;
  }
}

</style>
